import { atom, useAtom } from 'jotai';
import { atomWithImmer } from 'jotai/immer';
import { useUpdateAtom, useAtomValue, RESET } from 'jotai/utils';
export var defaultConfig = {};
export var configAtom = atomWithImmer(defaultConfig);
export var proxyConfigAtom = atom(function (get) {
  return get(configAtom);
}, function (get, set, action) {
  set(configAtom, action === RESET ? defaultConfig : action);
});

// update-only atom
export function useConfigAtomUpdate() {
  return useUpdateAtom(configAtom);
}

// read-write atom
export function useConfigAtom() {
  return useAtom(configAtom);
}

// read-only atom
export function useConfigAtomValues() {
  return useAtomValue(configAtom);
}